import { FeatureCollection } from 'geojson';
import { useEffect, useState } from 'react';
import { settings } from 'settings';
import Swal from 'sweetalert2';
import { Region } from 'types/orderTypes';
import Fetch from '../utils/fetch';

/* This is to fetch ZonesOverlay to show it in the map */
/* The map will highlight the zones in the specific region */
export const useZonesOverlay = (region: Region, disabled?: boolean) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<FeatureCollection | null>(null);

  useEffect(() => {
    const fetchZonesOverlay = async () => {
      let newZonesOverlay: FeatureCollection | null = null;

      try {
        const response = await Fetch.get({
          url: `${
            settings.autobundlerUrl
          }/api/zones/${region.toLocaleLowerCase()}`,
        });

        if (response.ok) {
          const result: FeatureCollection = await response.json();

          /* Set the Feature's ID using the Property's ID */
          const featuresWithId = result.features.map(feature => {
            return {
              ...feature,
              id: feature.properties.id,
            };
          });
          newZonesOverlay = { ...result, features: featuresWithId };
        } else {
          throw Error(`Error status : ${response.status}`);
        }
      } catch (e) {
        /* When the ZonesOverlay is not fetched properly, we just don't show it in the map */
        /* It should not blocking any user interaction */
        console.log('Error fetching the Zones Overlay', e);

        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'There was an error',
          showConfirmButton: true,
          html: `<div>Failed to fetch zones</div>`,
        });
      }

      /* Only set the data when the value is different */
      if (JSON.stringify(newZonesOverlay) !== JSON.stringify(data)) {
        setData(newZonesOverlay);
      }
      setLoading(false);
    };

    if (!disabled) {
      setLoading(true);
      fetchZonesOverlay().catch();
    }
  }, [region, disabled, data]);

  return { loading, data };
};
